export default {
    init () {
        // View front / back flip toggle
        $('.viewfront').off('click').click(function () {
            $(this).addClass('btn-success').removeClass('btn-primary primarybg hover primaryborder')
            $(this).closest('.previewControls').find('.viewback').removeClass('btn-success').addClass('btn-primary primarybg hover primaryborder')
            $(this).closest('.previewPrint').find('.preview-flip-container').removeClass('hover')
        })

        // View front / back flip toggle
        $('.viewback').off('click').click(function () {
            $(this).addClass('btn-success').removeClass('btn-primary primarybg hover primaryborder')
            $(this).closest('.previewControls').find('.viewfront').removeClass('btn-success').addClass('btn-primary primarybg hover primaryborder')
            $(this).closest('.previewPrint').find('.preview-flip-container').addClass('hover')
        })

        $('.viewguides').off('click').click(function () {
            if ($(this).is(':checked')) {
                $(this).closest('.filePreview').find('.previewMargins').removeClass('hide')
                $(this).closest('.filePreview').find('.previewPrint').addClass('hide')
            } else {
                $(this).closest('.filePreview').find('.previewMargins').addClass('hide')
                $(this).closest('.filePreview').find('.previewPrint').removeClass('hide')
            }
        })

        // View masks toggle
        $('.spotuvmask').off('click').click(function () {
            if ($(this).is(':checked')) {
                $(this).closest('.filePreview').find('.previewMask1').removeClass('hide')
            } else {
                $(this).closest('.filePreview').find('.previewMask1').addClass('hide')
            }
        })

        // View masks 2 toggle
        $('.foilmask').off('click').click(function () {
            if ($(this).is(':checked')) {
                $(this).closest('.filePreview').find('.previewMask2').removeClass('hide')
            } else {
                $(this).closest('.filePreview').find('.previewMask2').addClass('hide')
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/core/FileFlip.js